import { IActivityLog, TSetAuthState } from '../types';

import { persistAuthStore } from './authStoreLocalStorageUtils';

/**
 * This updates the activity log based on adding new or removing sessions.
 */
export function updateActivityLogCallback(set: TSetAuthState) {
  return function updateAuthStore(updatedLog: IActivityLog) {
    set(
      ({
        activeSession,
        activityLog,
        allSessionsById,
        allSessionsByIndex,
        allSessionsIndices,
      }) => {
        const newLog: IActivityLog = {
          ...activityLog,
          ...updatedLog,
          timestamp: Date.now(),
        };

        const persistState = {
          activityLog: newLog,
          activeSession,
          allSessionsById,
          allSessionsByIndex,
          allSessionsIndices,
        };

        persistAuthStore(persistState);

        return {
          activityLog: newLog,
        };
      }
    );
  };
}
